module.exports = __webpack_public_path__ + "files/9859216760519245075f81285a023699.svg";